<ng-template #loader>
  <div class="d-flex justify-content-center align-items-center" style="height: 200px;">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">{{ 'shared.loading' | translate }}</span>
    </div>
  </div>
</ng-template>

<ng-template #invalidMsg let-controlName="controlName">
  <span class="badge bg-danger ms-2" *ngIf="form.get(controlName)?.invalid && form.get(controlName)?.touched">
    {{ 'shared.required' | translate }}
  </span>
</ng-template>

<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{ 'onboarding.campaign_survey.title' | translate }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body px-5">
  <div class="row justify-content-center" *ngIf="!loading; else loader">
    <div class="col-10 py-4">
      <div class="alert alert-primary">
        {{ 'onboarding.campaign_survey.intro' | translate }}
      </div>
    </div>
    <div class="col-10">
      <form [formGroup]="form">
        <div class="mb-4">
          <label for="domain" class="form-label fw-bold">
            {{ 'onboarding.campaign_survey.domain_label' | translate }}
            <ng-container *ngTemplateOutlet="invalidMsg; context: { controlName: 'domain' }"></ng-container>
          </label>
          <input id="domain" class="form-control" formControlName="domain" />
          <small class="form-text">{{ 'onboarding.campaign_survey.domain_help' | translate }}</small>
        </div>

        <div class="mb-4">
          <label for="vertical" class="form-label fw-bold">
            {{ 'onboarding.campaign_survey.vertical_label' | translate }}
            <ng-container *ngTemplateOutlet="invalidMsg; context: { controlName: 'vertical' }"></ng-container>
          </label>
          <select id="vertical" class="form-select" formControlName="vertical">
            <option value="" disabled>{{ 'onboarding.campaign_survey.vertical_placeholder' | translate }}</option>
            <option *ngFor="let vertical of verticals" [ngValue]="vertical">{{ vertical.name }}</option>
          </select>
          <small class="form-text">{{ 'onboarding.campaign_survey.vertical_help' | translate }}</small>
        </div>

        <div class="mb-4">
          <label for="businessOverview" class="form-label fw-bold">
            {{ 'onboarding.campaign_survey.business_overview_label' | translate }}
            <ng-container *ngTemplateOutlet="invalidMsg; context: { controlName: 'businessOverview' }"></ng-container>
          </label>
          <textarea id="businessOverview" class="form-control" formControlName="businessOverview"></textarea>
          <small class="form-text">{{ 'onboarding.campaign_survey.business_overview_help' | translate }}</small>
        </div>

        <div class="mb-4">
          <label for="blogRestrictions" class="form-label fw-bold">
            {{ 'onboarding.campaign_survey.blog_restrictions_label' | translate }}
          </label>
          <input id="blogRestrictions" class="form-control" formControlName="blogRestrictions" />
          <small class="form-text">{{ 'onboarding.campaign_survey.blog_restrictions_help' | translate }}</small>
        </div>

        <div class="mb-4">
          <label for="location" class="form-label fw-bold">
            {{ 'onboarding.campaign_survey.location_label' | translate }}
            <ng-container *ngTemplateOutlet="invalidMsg; context: { controlName: 'location' }"></ng-container>
          </label>
          <div class="address-wrapper" *ngIf="!survey?.location">
            <gmp-place-autocomplete
              #placeInput
              [placeholder]="'onboarding.campaign_survey.location_placeholder' | translate"
              class="custom-autocomplete"
              (gmp-select)="onPlaceSelect($event)">
            </gmp-place-autocomplete>
          </div>
          <input *ngIf="survey?.location" id="location" class="form-control" formControlName="location" />
          <small class="form-text">{{ 'onboarding.campaign_survey.location_help' | translate }}</small>
        </div>

        <div class="mb-4">
          <label for="product" class="form-label fw-bold">
            {{ 'onboarding.campaign_survey.product_label' | translate }}
            <ng-container *ngTemplateOutlet="invalidMsg; context: { controlName: 'product' }"></ng-container>
          </label>
          <input id="product" class="form-control" formControlName="product" />
          <small class="form-text">{{ 'onboarding.campaign_survey.product_help' | translate }}</small>
        </div>

        <div class="mb-4">
          <label for="additionalProducts" class="form-label fw-bold">
            {{ 'onboarding.campaign_survey.additional_products_label' | translate }}
          </label>
          <input id="additionalProducts" class="form-control" formControlName="additionalProducts" />
          <small class="form-text">{{ 'onboarding.campaign_survey.additional_products_help' | translate }}</small>
        </div>
      </form>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button (click)="activeModal.dismiss()" class="btn btn-link">{{ 'shared.button_cancel' | translate }}</button>
  <button (click)="submit()" class="btn btn-primary" [disabled]="loading">{{ 'shared.button_submit' | translate }}</button>
</div>
